<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="grid-col flex-auto">
            <legend class="usa-legend usa-legend--large">Administrative Fee Admin</legend>
        </div>
        <div class="grid-col flex-auto margin-left-2">
            <ul class="usa-nav__primary usa-accordion">
                <li class="usa-nav__primary-item">
                    <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
                            data-tooltip="Click for more options"><span>&hellip;</span>
                    </button>
                    <ul id="more-actions" class="usa-nav__submenu" hidden>
                        <li class="usa-nav__submenu-item">
                            <a (click)="createEdit('create', createRateModal)"> Create Rate Record</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
    <div class="grid-row" *ngIf="iffRateError">
        <div class="usa-alert usa-alert--error" role="alert">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">
                        {{iffRateErrorMessage}}
                    </p>
                </div>
        </div>
    </div>
    <form id="iffRateTypeSearchForm" [formGroup]="iffRateTypeSearchForm" *ngIf="this.searchList.length > 1">
        <fieldset class="usa-fieldset">
            <div class="grid-row">
                <div class="grid-col-4">
                    <label class="usa-label" for="rateTypeSearch">Rate Type</label>
                    <select id="rateTypeSearch" class="usa-select" formControlName="rateTypeSearch" (change)="onMasterListRateTypeChange($event.target.value)">
                        <option value="null" selected disabled>Choose...</option>
                        <option *ngFor="let searchForEntry of searchList" [value]="searchForEntry.value">{{searchForEntry.name}}</option>
                    </select>
                </div>
            </div>
        </fieldset>
    </form>
  <div class="margin-top-5">
    <ag-grid-angular class="ag-theme-alpine margin-top-2"
                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                     [defaultColDef]="defaultColDef"
                     [rowData]="rowData"
                     [pagination]="true"
                     [gridOptions]="gridOptions"
                     [columnDefs]="columnDefs"
                     [rowClassRules] = "rowClassRules"
                     [components]="frameworkComponents"
                     (gridReady)="onGridReady($event)"
                     [getRowHeight]="getRowHeight"
                     ag-grid-resize>
    </ag-grid-angular>
  </div>
</div>

<div bsModal #createRateModal="bs-modal" style="text-align: center;" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="create-rate" [config]="{backdrop: 'static'}">
    <div class="usa-modal">
        <div class="usa-modal__content">
            <div class="usa-modal__main define-modal-style">
                <h2 class="usa-modal__heading" id="modal-2-heading">
                    {{title}}
                </h2>
                <div class="usa-prose">
                    <form [formGroup]="iffRatesForm">
                      <div *ngIf="iffRateTypeFrt; else hhgForm">
                        <div class="grid-row grid-gap-1">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="transportationType">Transportation Type</label>
                            <select id="transportationType" class="usa-select maxw-full" formControlName="transportationType" [attr.disabled]="updateDisabled?'':null">
                              <option value='' selected disabled>Choose...</option>
                              <option *ngFor="let iffTransportationType of iffTransportationTypes"
                                      [value]="iffTransportationType.value">{{iffTransportationType.name}}</option>
                            </select>
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="moveType">Move Type</label>
                            <select id="moveType" class="maxw-full usa-select" formControlName="moveType" [attr.disabled]="updateDisabled?'':null">
                              <option value='' selected disabled>Choose...</option>
                              <option *ngFor="let iffMoveType of iffMoveTypes" [value]="iffMoveType.value">
                                {{iffMoveType.name}}</option>
                            </select>
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="effectiveDate">PickUp Date/Effective Date</label>
                            <input type="text" id="effectiveDate" class="maxw-full usa-input" placeholder="mm/dd/yyyy" [attr.disabled]="updateDisabled?'':null" formControlName="effectiveDate" [value]="this.iffRatesForm.get('effectiveDate').value | date: 'MMM d, y'" bsDatepicker
                                   [bsConfig]="datePickerConfig" placement="bottom" [ngClass]="{
                                                                'border-success': this.iffRatesForm.get('effectiveDate').valid && (this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty),
                                                                'border-danger': this.iffRatesForm.get('effectiveDate').invalid && (this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty)
                                                            }">
                            <div *ngIf="this.iffRatesForm.get('effectiveDate').invalid && this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty">
                              <div class="define-text-secondary" *ngIf="this.iffRatesForm.get('effectiveDate').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg>Effective Date is required
                              </div>
                            </div>
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="iffRateTypeFrt">
                            <label class="usa-label" for="expire_Date">Expiration Date</label>
                            <input type="text" id="expire_Date" class="maxw-full usa-input" placeholder="mm/dd/yyyy" formControlName="expireDate" [value]="this.iffRatesForm.get('expireDate').value | date: 'MMM d, y'" bsDatepicker [bsConfig]="datePickerConfig" placement="bottom"
                                   [ngClass]="{
                                    'border-success': this.iffRatesForm.get('expireDate').valid && (this.iffRatesForm.get('expireDate').touched || this.iffRatesForm.get('expireDate').dirty),
                                    'border-danger': this.iffRatesForm.get('expireDate').invalid && (this.iffRatesForm.get('expireDate').touched || this.iffRatesForm.get('expireDate').dirty)
                                }">
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="rateInPercentage">Administrative Fee (%)</label>
                            <input type="text" id="rateInPercentage" [attr.disabled]="updateDisabled?'':null" formControlName="rateInPercentage" class="maxw-full usa-input" maxlength='5'>
                          </div>

                        </div>
                        <div class="grid-row grid-gap-1">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <ul class="usa-button-group">
                              <li class="usa-button-group__item" *ngIf="this.isCreate">
                                <button type="button" class="usa-button" (click)="createIFFRate(this.iffRatesForm.value);createRateModal.hide();" [disabled]="this.iffRatesForm.invalid || (this.iffRatesForm.get('rateInPercentage').value==='')">
                                  Create
                                </button>
                              </li>
                              <!-- <li class="usa-button-group__item" *ngIf="!this.isCreate">
                                  <button type="button" class="usa-button" (click)="updateIFFRate(this.iffRatesForm.value);createRateModal.hide();" [disabled]="this.iffRatesForm.invalid">Save
                                  </button>
                              </li>
                              <li class="usa-button-group__item" *ngIf="!this.isCreate">
                                  <button type="button" class="usa-button" (click)="createRateModal.hide()">Close
                                  </button>
                              </li> -->
                            </ul>
                          </div>
                        </div>
                      </div>
                      <ng-template #hhgForm>
                        <div class="grid-row grid-gap-1">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="moveType">Move Type</label>
                            <select id="moveTypeHhg" class="maxw-full usa-select" formControlName="moveType" [attr.disabled]="updateDisabled?'':null" (change)="onHhgMoveTypeChange($event)">
                              <option value='' selected disabled>Choose...</option>
                              <option *ngFor="let iffMoveType of iffMoveTypes" [value]="iffMoveType.value">
                                {{iffMoveType.name}}</option>
                            </select>
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="transportationType">Transportation Type</label>
                            <select id="transportationTypeHhg" class="usa-select maxw-full" formControlName="transportationType" [attr.disabled]="updateDisabled?'':null">
                              <option value='' selected disabled>Choose...</option>
                              <option *ngFor="let iffTransportationType of iffTransportationTypes"
                                      [value]="iffTransportationType.value">{{iffTransportationType.name}}</option>
                            </select>
                          </div>

                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="effectiveDate">PickUp Date/Effective Date</label>
                            <input type="text" id="effectiveDateHhg" class="maxw-full usa-input" placeholder="mm/dd/yyyy" [attr.disabled]="updateDisabled?'':null" formControlName="effectiveDate" [value]="this.iffRatesForm.get('effectiveDate').value | date: 'MMM d, y'" bsDatepicker
                                   [bsConfig]="datePickerConfig" placement="bottom" [ngClass]="{
                                                                'border-success': this.iffRatesForm.get('effectiveDate').valid && (this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty),
                                                                'border-danger': this.iffRatesForm.get('effectiveDate').invalid && (this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty)
                                                            }">
                            <div *ngIf="this.iffRatesForm.get('effectiveDate').invalid && this.iffRatesForm.get('effectiveDate').touched || this.iffRatesForm.get('effectiveDate').dirty">
                              <div class="define-text-secondary" *ngIf="this.iffRatesForm.get('effectiveDate').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                </svg>Effective Date is required
                              </div>
                            </div>
                          </div>
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                            <label class="usa-label" for="rateInPercentage">Administrative Fee (%)</label>
                            <input type="text" id="rateInPercentageHhg" [attr.disabled]="updateDisabled?'':null" formControlName="rateInPercentage" class="maxw-full usa-input" maxlength='5'>
                          </div>

                        </div>
                        <div class="grid-row grid-gap-1">
                          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                            <ul class="usa-button-group">
                              <li class="usa-button-group__item" *ngIf="this.isCreate">
                                <button type="button" class="usa-button" (click)="createIFFRate(this.iffRatesForm.value);createRateModal.hide();" [disabled]="this.iffRatesForm.invalid || (this.iffRatesForm.get('rateInPercentage').value==='')">
                                  Create
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </ng-template>

                    </form>
                </div>
            </div>
            <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="createRateModal.hide()" data-close-modal>
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>

</div>
